import _ from "lodash";
import { v4 as uuidv4 } from "uuid";

import store from "../store";

import payconiqIcon from "../assets/images/payconiq-logo.png";
import bancontactIcon from "../assets/images/payments/Bancontact.svg";
import idealIcon from "../assets/images/payments/ideal-logo.svg";
import mastercardIcon from "../assets/images/payments/mastercard.svg";
import bonsaiIcon from "../assets/images/payments/logo_bonsai.svg";
import walletIcon from "../assets/images/payments/logo_wallet.svg";
import terminalIcon from "../assets/images/payments/terminal.svg";
import betaalInzaakicon from "../assets/images/payments/zaak.png";
import qrCodeIcon from "../assets/images/payments/qrCode.png";
import MealVoucherIcon from "../assets/images/payments/mealVoucherIcon.svg";
/**
 *
 * @param {Object} cartItem An entire cartItem object including the `OrderItemAdditions'-array
 * @returns {Object} Returns the new object, but is not needed to resasign to a variable if variable is not a `const`
 */
export const sortAdditonsById = (cartItem) => {
  delete cartItem._cartItemId;
  delete cartItem._cartItemTime;

  // order OrderItemAdditions by their id
  const sorted = _.orderBy(cartItem.OrderItemAdditions, "Addition.Id");

  // create and return a new object where the `OrderItemAdditions`value is overwritten by the sorted one
  const merged = { ...cartItem, OrderItemAdditions: sorted };
  return merged;
};

// const equalComparator = (a, b) => {
//   a = sortAdditonsById(a);
//   b = sortAdditonsById(b);

//   return (
//     _.isEqual(a.Id, b.Id) &&
//     _.isEqual(a.OrderItemAdditions, b.OrderItemAdditions)
//   );
// };

const findCartGroupAmount = (cartItems, group) =>
  // return the amount of items in this array
  _.filter(
    // Filter all the given cart items
    cartItems,

    // Find all items that are equal to the cart items group (equal cart items that are grouped into one item)
    (f) => _.isEqual(group, f)
  ).length;

export const sortCartByAdditions = (allCartItems) => {
  // Apply sorting to addtions within cart items
  const sortedCartItems = allCartItems.map(sortAdditonsById);

  // Filter out equal cart items
  const groupedCartItems = _.uniqWith(sortedCartItems, _.isEqual);

  // Return each unique cart item and find every occurrence in the total of all cart items
  return groupedCartItems
    .map((group) => ({
      cartItem: group, // Return `group`as `cartItem`for easier destructuring in v-for loop
      amount: findCartGroupAmount(sortedCartItems, group),
    }))
    .reverse();
};

export const paymentMethodIcon = (paymentId) =>
  ({
    1: payconiqIcon,
    2: bancontactIcon,
    3: idealIcon,
    4: betaalInzaakicon,
    5: mastercardIcon,
    6: bonsaiIcon,
    7: walletIcon,
    8: terminalIcon,
    9: walletIcon,
    10: qrCodeIcon,
    13: MealVoucherIcon,
  }[paymentId]);

/**
 *
 * @param {Object} cartItem The entire cartItem object as send or recieved to and from the back-end
 * @param {Array} ignoreMeta An array of properties that need to be ignored
 * @returns {Object} The merged `cartItem`, however, the new object should be reassigned to a variable (propably the variable where the old data came from)
 */
export const setCartItemMeta = (cartItem, ignoreMeta = []) => {
  const dataMerger = (keyId, mergeableData) => {
    if (ignoreMeta && _.includes(ignoreMeta, keyId)) return;
    return { [keyId]: mergeableData };
  };

  return {
    ...cartItem,
    ...dataMerger("_cartItemId", uuidv4()),
    ...dataMerger("_cartItemTime", new Date()),
  };
};

/**
 *
 * @param {Number} price The amount of money that must be displayed
 * @param {String} [currency] The prefix for the price, gets the currency from the store if none is given
 * @returns {String} The parsed price of an item
 */
export const pricify = (price, currency) => {
  const parsed = (Math.round(price * 100) / 100).toFixed(2);
  const c = (currency || store.state.currency) + " ";
  return c + parsed;
};
